import React, { useState, useEffect } from "react";
import {
  Card, Row, Col, Statistic, Typography, Layout, theme,
  Table, Tag, Progress, Space, Avatar, Tooltip, DatePicker,
  TimePicker, Spin, FloatButton
} from "antd";
import {
  FaPhoneAlt, FaChartLine, FaUsers, FaMapMarkerAlt,
  FaCalendarAlt, FaChartBar, FaChartArea, FaQuestionCircle,
  FaExclamationTriangle, FaClock, FaCalendarWeek,
  FaGlobeAmericas, FaCity, FaDatabase, FaRegChartBar
} from "react-icons/fa";
import {
  PhoneOutlined, UserOutlined, EnvironmentOutlined,
  CalendarOutlined, ClockCircleOutlined, RiseOutlined,
  BarChartOutlined, LineChartOutlined, PieChartOutlined,
  WhatsAppOutlined, WarningOutlined, SyncOutlined,
  ReloadOutlined, UpOutlined, DashboardOutlined
} from "@ant-design/icons";
import {
  AreaChart, Area, BarChart, Bar, LineChart, Line,
  XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip,
  ResponsiveContainer, PieChart, Pie, Cell, Legend
} from "recharts";
import dayjs from "dayjs";
import api from "../api/Api";

const { Title, Text } = Typography;
const { Content } = Layout;
const { useToken } = theme;
const { RangePicker } = DatePicker;

const Dashboard = () => {
  const { token } = useToken();

  // Estados originais do Dashboard
  const [datas, setDatas] = useState(null);
  const [totalChamadas, settotalChamadas] = useState(0);
  const [totalAtendidas, settotalAtendidas] = useState(0);
  const [totaln_Atendidas, settotaln_Atendidas] = useState(0);
  const [totalAbandonadas, settotalAbandonadas] = useState(0);
  const [dataProvincias, setdataProvincias] = useState([]);
  const [dataMensal, setdataMensal] = useState([]);
  const [dataHorarioPico, setdataHorarioPico] = useState([]);
  const [horaInicio, setHoraInicio] = useState(null);
  const [horaFim, setHoraFim] = useState(null);
  const [reclamacoesData, setReclamacoesData] = useState([]);
  const [solicitacoesData, setSolicitacoesData] = useState([]);
  const [informacoesData, setInformacoesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [hPico, sethPico] = useState('');
  const [esperaMedio, setesperaMedio] = useState('');
  const [chamadaMedio, setchamadaMedio] = useState('');
  const [atendidasP, setatendidasP] = useState('');
  const [n_atendidasP, setn_atendidasP] = useState('');
  const [abandonadasP, setabandonadasP] = useState('');

  const mesmoDia =
    datas && datas[0] && datas[1]
      ? datas[0].format("YYYY-MM-DD") === datas[1].format("YYYY-MM-DD")
      : false;

  useEffect(() => {
    document.title = "DASHBOARD";
    if (datas && datas[0] && datas[1]) {
      fechDia();
       
    } else {
      fechAno();
       
    }
  }, [datas, horaInicio, horaFim]);

  useEffect(() => {
    fetchReclamacoes();
    fetchSolicitacoes();
    fetchInformacoes();
    fechMetricas();
 
  }, []);

  const fechAno = () => {
    fechDashboardAno();
    fechPorProvinciaAno();
    fetchPorMes();
    fetchHorarioPicoAno();
    fechMetricas();
  };

  const fechDia = () => {
    fechDashboard();
    fechPorProvincia();
    fetchPorDia();
    fetchHorarioPicoDia();
    fechMetricas();
  };

  const fetchHorarioPicoAno = async () => {
    try {
      setLoading(true);
      const dados = {
        dataInicio: '',
        dataFim: '',
        horaInicio: '',
        horaFim: ''
      };
      const response = await api.ListHorarioPico(dados);
      if (Array.isArray(response)) setdataHorarioPico(response);
      setLastUpdated(new Date());
    } catch (error) {
      console.error("Erro ao buscar horário pico:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchHorarioPicoDia = async () => {
    try {
      setLoading(true);
      const dados = {
        dataInicio: datas[0].format("YYYY-MM-DD"),
        dataFim: datas[1].format("YYYY-MM-DD"),
        horaInicio: mesmoDia && horaInicio ? horaInicio.format("HH:mm:ss") : null,
        horaFim: mesmoDia && horaFim ? horaFim.format("HH:mm:ss") : null,
      };
      const response = await api.ListHorarioPico(dados);
      if (Array.isArray(response)) setdataHorarioPico(response);
      setLastUpdated(new Date());
    } catch (error) {
      console.error("Erro ao buscar horário pico:", error);
    } finally {
      setLoading(false);
    }
  };




  const fechMetricas = async () => {
    try {
      setLoading(true);
let dados = {};

if (datas && datas.length === 2) {
  dados = {
    dataInicio: datas[0].format("YYYY-MM-DD"),
    dataFim: datas[1].format("YYYY-MM-DD"),
  };
}

    
      const response = await api.ListMetricas(dados);
 

 


      if (response && typeof response === "object") {
        sethPico(response.hora_pico.hora + " - " + response.hora_pico.total + " chamadas");
        setesperaMedio(response.tempo_medio_espera);
        setchamadaMedio(response.tempo_medio_duracao);
        setatendidasP(response.status.perc_completed);
        setn_atendidasP(response.status.perc_no_answer);
        setabandonadasP(response.status.perc_abandoned);
      }
      setLastUpdated(new Date());
    } catch (error) {
      console.error("Erro ao buscar dashboard:", error);
    } finally {
      setLoading(false);
    }
  };







  const fechDashboard = async () => {
    try {
      setLoading(true);
      const dados = {
        dataInicio: datas[0].format("YYYY-MM-DD"),
        dataFim: datas[1].format("YYYY-MM-DD"),
        horaInicio: mesmoDia && horaInicio ? horaInicio.format("HH:mm:ss") : null,
        horaFim: mesmoDia && horaFim ? horaFim.format("HH:mm:ss") : null,
      };
      const response = await api.ListDashboard(dados);
      if (response && typeof response === "object") {
        settotalChamadas(response.todas);
        settotalAtendidas(response.atendidas);
        settotaln_Atendidas(response.n_atendidas);
        settotalAbandonadas(response.abandonadas);
      }
      setLastUpdated(new Date());
    } catch (error) {
      console.error("Erro ao buscar dashboard:", error);
    } finally {
      setLoading(false);
    }
  };

  const fechDashboardAno = async () => {
    try {
      setLoading(true);
      const response = await api.ListDashboardAno();
      if (response && typeof response === "object") {
        settotalChamadas(response.todas);
        settotalAtendidas(response.atendidas);
        settotaln_Atendidas(response.n_atendidas);
        settotalAbandonadas(response.abandonadas);
      }
      setLastUpdated(new Date());
    } catch (error) {
      console.error("Erro ao buscar dashboard anual:", error);
    } finally {
      setLoading(false);
    }
  };

  const fechPorProvinciaAno = async () => {
    try {
      const response = await api.ListChamadasProvinciaAno();
      if (Array.isArray(response)) {
        const formatado = response.map((item) => ({
          provincia: item.descricao,
          chamadas: item.total_chamadas,
        }));
        setdataProvincias(formatado);
      }
    } catch (error) {
      console.error("Erro ao buscar províncias:", error);
    }
  };

  const fechPorProvincia = async () => {
    try {
      const dados = {
        dataInicio: datas[0].format("YYYY-MM-DD"),
        dataFim: datas[1].format("YYYY-MM-DD"),
        horaInicio: mesmoDia && horaInicio ? horaInicio.format("HH:mm:ss") : null,
        horaFim: mesmoDia && horaFim ? horaFim.format("HH:mm:ss") : null,
      };
      const response = await api.ListChamadasProvincia(dados);
      if (Array.isArray(response)) {
        const formatado = response.map((item) => ({
          provincia: item.descricao,
          chamadas: item.total_chamadas,
        }));
        setdataProvincias(formatado);
      }
    } catch (error) {
      console.error("Erro ao buscar províncias:", error);
    }
  };

  const fetchPorDia = async () => {
    try {
      const dados = {
        dataInicio: datas[0].format("YYYY-MM-DD"),
        dataFim: datas[1].format("YYYY-MM-DD"),
        horaInicio: mesmoDia && horaInicio ? horaInicio.format("HH:mm:ss") : null,
        horaFim: mesmoDia && horaFim ? horaFim.format("HH:mm:ss") : null,
      };
      const response = await api.ListChamadaDia(dados);
      if (Array.isArray(response)) {
        const formatado = response.map((item) => ({
          mes: item.dia,
          chamadas: item.total_chamadas,
        }));
        setdataMensal(formatado);
      }
    } catch (error) {
      console.error("Erro ao buscar chamadas por dia:", error);
    }
  };

  const fetchPorMes = async () => {
    try {
      const response = await api.ListChamadasAno();
      if (Array.isArray(response)) {
        const formatado = response.map((item) => ({
          mes: item.mes,
          chamadas: item.total_chamadas,
        }));
        setdataMensal(formatado);
      }
    } catch (error) {
      console.error("Erro ao buscar chamadas por mês:", error);
    }
  };

  const fetchReclamacoes = async () => {
    try {
      const response = await api.ListDashboardReclamacao();
      if (Array.isArray(response)) {
        setReclamacoesData(response.slice(0, 5));
      }
    } catch (error) {
      console.error("Erro ao carregar reclamações", error);
    }
  };

  const fetchSolicitacoes = async () => {
    try {
      const response = await api.ListDashboardSolicitacao();
      if (Array.isArray(response)) {
        setSolicitacoesData(response.slice(0, 5));
      }
    } catch (error) {
      console.error("Erro ao carregar solicitações", error);
    }
  };

  const fetchInformacoes = async () => {
    try {
      const response = await api.ListDashboardInformacao();
      if (Array.isArray(response)) {
        setInformacoesData(response.slice(0, 5));
      }
    } catch (error) {
      console.error("Erro ao carregar informações", error);
    }
  };

  const handleRefresh = () => {
    if (datas && datas[0] && datas[1]) {
      fechDia();
    } else {
      fechAno();
    }
    fetchReclamacoes();
    fetchSolicitacoes();
    fetchInformacoes();
  };

  const COLORS = [
    token.colorPrimary, token.colorSuccess, token.colorWarning,
    token.colorError, token.colorInfo, token.colorProcessing,
    '#722ED1', '#13C2C2', '#F5222D', '#FA8C16', '#52C41A'
  ];

  const gradientColor = token.colorPrimary;

  // Componente customizado para barra com topo arredondado
  const RoundedTopBar = (props) => {
    const { fill, x, y, width, height } = props;
    
    if (!height || height <= 0) return null;

    const radius = 12;
    const adjustedRadius = Math.min(radius, width / 2, height);

    return (
      <path
        d={`
          M ${x},${y + height}
          L ${x},${y + adjustedRadius}
          Q ${x},${y} ${x + adjustedRadius},${y}
          L ${x + width - adjustedRadius},${y}
          Q ${x + width},${y} ${x + width},${y + adjustedRadius}
          L ${x + width},${y + height}
          Z
        `}
        fill={fill}
      />
    );
  };

  // Componente de Cards de Estatísticas
  const StatCards = () => (
    <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
      <Col xs={24} sm={12} lg={6}>
        <Card 
          hoverable
          style={{
            background: `linear-gradient(135deg, ${token.colorPrimary} 0%, ${token.colorPrimaryActive} 100%)`,
            borderRadius: '12px',
            border: 'none',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            height: '100%'
          }}
          bodyStyle={{ padding: '20px' }}
        >
          <Statistic
            title={
              <Space style={{ color: 'white', opacity: 0.9 }}>
                <PhoneOutlined />
                <Text style={{ color: 'white' }}>Total Chamadas</Text>
              </Space>
            }
            value={totalChamadas}
            valueStyle={{ 
              color: 'white',
              fontSize: '32px',
              fontWeight: 'bold'
            }}
            prefix={<FaPhoneAlt />}
          />
          <div style={{ marginTop: '12px' }}>
            <Progress 
              percent={100}
              strokeColor="white"
              trailColor="rgba(255, 255, 255, 0.2)"
              showInfo={false}
              size="small"
            />
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card 
          hoverable
          style={{
            background: `linear-gradient(135deg, ${token.colorSuccess} 0%, ${token.colorSuccessActive} 100%)`,
            borderRadius: '12px',
            border: 'none',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            height: '100%'
          }}
          bodyStyle={{ padding: '20px' }}
        >
          <Statistic
            title={
              <Space style={{ color: 'white', opacity: 0.9 }}>
                <FaChartLine />
                <Text style={{ color: 'white' }}>Chamadas Atendidas</Text>
              </Space>
            }
            value={totalAtendidas}
            valueStyle={{ 
              color: 'white',
              fontSize: '32px',
              fontWeight: 'bold'
            }}
            prefix={<FaRegChartBar />}
            suffix={
              <Tag color="white" style={{ color: token.colorSuccess, fontSize: '12px' }}>
                {atendidasP.replace(".00","")+"%"}
              </Tag>
            }
          />
          <div style={{ marginTop: '12px' }}>
            <Progress 
              percent={atendidasP}
              strokeColor="white"
              trailColor="rgba(255, 255, 255, 0.2)"
              showInfo={false}
              size="small"
            />
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card 
          hoverable
          style={{
            background: `linear-gradient(135deg, ${token.colorError} 0%, ${token.colorErrorActive} 100%)`,
            borderRadius: '12px',
            border: 'none',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            height: '100%'
          }}
          bodyStyle={{ padding: '20px' }}
        >
          <Statistic
            title={
              <Space style={{ color: 'white', opacity: 0.9 }}>
                <WarningOutlined />
                <Text style={{ color: 'white' }}>Não Atendidas</Text>
              </Space>
            }
            value={totaln_Atendidas}
            valueStyle={{ 
              color: 'white',
              fontSize: '32px',
              fontWeight: 'bold'
            }}
            prefix={<FaExclamationTriangle />}
            suffix={
              <Tag color="white" style={{ color: token.colorError, fontSize: '12px' }}>
                {n_atendidasP+"%"}
              </Tag>
            }
          />
          <div style={{ marginTop: '12px' }}>
            <Progress 
              percent={n_atendidasP}
              strokeColor="white"
              trailColor="rgba(255, 255, 255, 0.2)"
              showInfo={false}
              size="small"
            />
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card 
          hoverable
          style={{
            background: `linear-gradient(135deg, ${token.colorWarning} 0%, ${token.colorWarningActive} 100%)`,
            borderRadius: '12px',
            border: 'none',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            height: '100%'
          }}
          bodyStyle={{ padding: '20px' }}
        >
          <Statistic
            title={
              <Space style={{ color: 'white', opacity: 0.9 }}>
                <ClockCircleOutlined />
                <Text style={{ color: 'white' }}>Abandonadas</Text>
              </Space>
            }
            value={totalAbandonadas}
            valueStyle={{ 
              color: 'white',
              fontSize: '32px',
              fontWeight: 'bold'
            }}
            prefix={<FaClock />}
            suffix={
              <Tag color="white" style={{ color: token.colorWarning, fontSize: '12px' }}>
                {abandonadasP+"%"}
              </Tag>
            }
          />
          <div style={{ marginTop: '12px' }}>
            <Progress 
              percent={abandonadasP}
              strokeColor="white"
              trailColor="rgba(255, 255, 255, 0.2)"
              showInfo={false}
              size="small"
            />
          </div>
        </Card>
      </Col>
    </Row>
  );

  // Gráfico de Chamadas por Província
  const ChamadasPorProvinciaChart = () => (
    <Card
      title={
        <Space>
          <FaGlobeAmericas />
          <span>Chamadas por Província</span>
        </Space>
      }
      style={{ borderRadius: '12px', marginBottom: '24px' }}
      hoverable
    >
      <div style={{ height: '300px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={dataProvincias}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke={token.colorBorder} />
            <XAxis 
              dataKey="provincia" 
              tick={{ fill: token.colorTextSecondary }}
              axisLine={{ stroke: token.colorBorder }}
            />
            <YAxis 
              tick={{ fill: token.colorTextSecondary }}
              axisLine={{ stroke: token.colorBorder }}
            />
            <RechartsTooltip 
              contentStyle={{ 
                backgroundColor: token.colorBgContainer,
                border: `1px solid ${token.colorBorder}`,
                borderRadius: '8px'
              }}
            />
            <Bar 
              dataKey="chamadas" 
              fill={token.colorPrimary}
              radius={[8, 8, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );

  // Gráfico de Chamadas por Hora com bordas arredondadas
  const ChamadasPorHoraChart = () => (
    <Card
      title={
        <Space>
          <ClockCircleOutlined />
          <span>Chamadas por Hora</span>
        </Space>
      }
      style={{ borderRadius: '12px', marginBottom: '24px' }}
      hoverable
    >
      <div style={{ height: '350px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={dataHorarioPico}>
            <CartesianGrid strokeDasharray="3 3" stroke={token.colorBorder} />
            <XAxis 
              dataKey="hora" 
              tick={{ fill: token.colorTextSecondary }}
              axisLine={{ stroke: token.colorBorder }}
            />
            <YAxis 
              tick={{ fill: token.colorTextSecondary }}
              axisLine={{ stroke: token.colorBorder }}
            />
            <RechartsTooltip
              contentStyle={{ 
                backgroundColor: token.colorBgContainer,
                border: `1px solid ${token.colorBorder}`,
                borderRadius: '8px'
              }}
              content={({ active, payload, label }) => {
                if (active && payload && payload.length) {
                  const completadas = payload.find(p => p.dataKey === "Completada")?.value || 0;
                  const semResposta = payload.find(p => p.dataKey === "Sem Resposta")?.value || 0;
                  const abandonadas = payload.find(p => p.dataKey === "Abandonada")?.value || 0;
                  const total = payload[0]?.payload?.Total || 0;

                  return (
                    <div
                      style={{
                        backgroundColor: token.colorBgContainer,
                        border: `1px solid ${token.colorBorder}`,
                        borderRadius: "8px",
                        padding: "10px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                      }}
                    >
                      <p style={{ margin: 0, fontWeight: "bold" }}>{label}</p>
                      <p style={{ color: "#52c41a", margin: 0 }}>Completada: {completadas}</p>
                      <p style={{ color: "#ff4d4f", margin: 0 }}>Sem Resposta: {semResposta}</p>
                      <p style={{ color: "#fa8c16", margin: 0 }}>Abandonada: {abandonadas}</p>
                      <hr style={{ margin: "6px 0" }} />
                      <p style={{ margin: 0, fontWeight: "bold", color: "#000" }}>
                        Total: {total}
                      </p>
                    </div>
                  );
                }
                return null;
              }}
            />
            <Legend />
            <Bar dataKey="Completada" stackId="a" fill="#52c41a" />
            <Bar dataKey="Sem Resposta" stackId="a" fill="#ff4d4f" />
            <Bar dataKey="Abandonada" stackId="a" fill="#fa8c16" shape={<RoundedTopBar />} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );

  // Gráfico de Chamadas por Mês/Dia
  const ChamadasPorPeriodoChart = () => (
    <Card
      title={
        <Space>
          <CalendarOutlined />
          <span>{datas ? "Chamadas por Dia" : "Chamadas por Mês"}</span>
        </Space>
      }
      style={{ borderRadius: '12px', marginBottom: '24px' }}
      hoverable
    >
      <div style={{ height: '300px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={dataMensal}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorChamadas" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={gradientColor} stopOpacity={0.8}/>
                <stop offset="95%" stopColor={gradientColor} stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke={token.colorBorder} />
            <XAxis 
              dataKey="mes" 
              tick={{ fill: token.colorTextSecondary }}
              axisLine={{ stroke: token.colorBorder }}
            />
            <YAxis 
              tick={{ fill: token.colorTextSecondary }}
              axisLine={{ stroke: token.colorBorder }}
            />
            <RechartsTooltip 
              contentStyle={{ 
                backgroundColor: token.colorBgContainer,
                border: `1px solid ${token.colorBorder}`,
                borderRadius: '8px'
              }}
              labelStyle={{ color: token.colorPrimary }}
            />
            <Area 
              type="monotone" 
              dataKey="chamadas" 
              stroke={token.colorPrimary}
              fillOpacity={1}
              fill="url(#colorChamadas)"
              strokeWidth={2}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );

  // Tabelas Top 5
  const TopTable = ({ title, icon, data, color, extraIcon }) => {
    const columns = [
      {
        title: 'Rank',
        dataIndex: 'rank',
        key: 'rank',
        width: 60,
        render: (_, record, index) => (
          <Avatar 
            size="small"
            style={{
              backgroundColor: COLORS[index % COLORS.length],
              color: 'white',
              fontWeight: 'bold'
            }}
          >
            {index + 1}
          </Avatar>
        ),
      },
      {
        title: 'Descrição',
        dataIndex: 'pacote',
        key: 'pacote',
        ellipsis: true,
        render: (text) => (
          <Tooltip title={text}>
            <Space>
              <FaQuestionCircle style={{ color: token.colorPrimary }} />
              <Text style={{ fontSize: '12px' }}>{text}</Text>
            </Space>
          </Tooltip>
        ),
      },
      {
        title: 'Total',
        dataIndex: 'total_chamadas',
        key: 'total_chamadas',
        width: 80,
        render: (total) => (
          <Tag color={color} style={{ fontWeight: 'bold' }}>
            {total}
          </Tag>
        ),
      },
    ];

    return (
      <Card
        title={
          <Space>
            {icon}
            <span>{title}</span>
          </Space>
        }
        extra={extraIcon}
        style={{ borderRadius: '12px', height: '100%' }}
        hoverable
      >
        <Table
          columns={columns}
          dataSource={data.map((item, index) => ({
            ...item,
            key: index,
            rank: index + 1
          }))}
          pagination={false}
          size="small"
          loading={loading}
        />
      </Card>
    );
  };

  // KPIs adicionais
  const AdditionalKPIs = () => (
    <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
      <Col xs={24} sm={12} md={6}>
        <Card size="small" hoverable>
          <Statistic
            title="Média Diária"
            value={totalChamadas > 0 ? Math.round(totalChamadas / 30) : 0}
            prefix={<FaCalendarWeek />}
            suffix="chamadas"
            valueStyle={{ color: token.colorPrimary }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card size="small" hoverable>
          <Statistic
            title="Pico Horário"
            value={
             hPico 
            }
            prefix={<FaClock />}
            valueStyle={{ color: token.colorPrimary }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card size="small" hoverable>
          <Statistic
            title="Tempo médio de espera"
            value={
              esperaMedio
            }
            prefix={<FaClock />}
            valueStyle={{ color: token.colorPrimary }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card size="small" hoverable>
          <Statistic
            title="Tempo médio em chamada"
            value={chamadaMedio}
            prefix={<FaClock />}
            valueStyle={{ color: loading ? token.colorWarning : token.colorPrimary }}
          />
        </Card>
      </Col>
    </Row>
  );

  return (
    <Layout style={{ background: token.colorBgLayout }}>
      <Content style={{ padding: '24px' }}>
        {loading && (
          <div style={{ 
            position: 'fixed', 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0, 
            background: 'rgba(255, 255, 255, 0.7)', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            zIndex: 1000 
          }}>
            <Spin size="large" tip="Carregando dados do dashboard..." />
          </div>
        )}
        
        <div>
          {/* Cabeçalho */}
          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "16px"
            }}
          >
            <h2 style={{ margin: 0, fontWeight: 700, color: "#2c3e50" }}>
              <DashboardOutlined style={{ marginRight: '8px' }} />
              Dashboard
            </h2>
            <Space direction="horizontal" wrap>
              <RangePicker
                format="DD/MM/YYYY"
                value={datas}
                onChange={(values) => { 
                  setDatas(values); 
                  setHoraInicio(null); 
                  setHoraFim(null); 
                }}
                allowClear
                style={{
                  borderRadius: "8px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              />
              {mesmoDia && (
                <>
                  <TimePicker
                    format="HH:mm"
                    placeholder="Hora Início"
                    value={horaInicio}
                    onChange={(val) => setHoraInicio(val)}
                    style={{ borderRadius: "8px" }}
                  />
                  <TimePicker
                    format="HH:mm"
                    placeholder="Hora Fim"
                    value={horaFim}
                    onChange={(val) => setHoraFim(val)}
                    style={{ borderRadius: "8px" }}
                  />
                </>
              )}
            </Space>
          </div>
          
          {/* Estatísticas Principais */}
          <StatCards />
          
          {/* KPIs Adicionais */}
          <AdditionalKPIs />
          
          {/* Gráfico de Chamadas por Província */}
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <ChamadasPorProvinciaChart />
            </Col>
          </Row>
          
          {/* Gráfico de Chamadas por Hora */}
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <ChamadasPorHoraChart />
            </Col>
          </Row>
          
          {/* Gráfico de Chamadas por Período */}
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <ChamadasPorPeriodoChart />
            </Col>
          </Row>
          
          {/* Tabelas Top 5 */}
          <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
            <Col xs={24} md={8}>
              <TopTable
                title="Top 5 Reclamações"
                icon={<FaExclamationTriangle />}
                data={reclamacoesData}
                color="red"
                extraIcon={<FaDatabase style={{ color: token.colorError }} />}
              />
            </Col>
            <Col xs={24} md={8}>
              <TopTable
                title="Top 5 Solicitações"
                icon={<FaQuestionCircle />}
                data={solicitacoesData}
                color="blue"
                extraIcon={<FaDatabase style={{ color: token.colorPrimary }} />}
              />
            </Col>
            <Col xs={24} md={8}>
              <TopTable
                title="Top 5 Informações"
                icon={<FaChartBar />}
                data={informacoesData}
                color="green"
                extraIcon={<FaDatabase style={{ color: token.colorSuccess }} />}
              />
            </Col>
          </Row>
        </div>

        {/* Botões flutuantes */}
        <FloatButton.BackTop 
          icon={<UpOutlined />}
          style={{ right: 24, bottom: 24 }}
          visibilityHeight={300}
        />
        
 
      </Content>
    </Layout>
  );
};

export default Dashboard;